/* eslint-disable import/no-cycle */
import pLimit from 'p-limit';
import * as types from './types';
import storageApi from '@/modules/storage/api/storageApi';

// Shared across all callers so the true number of concurrent GET /file requests
// (e.g. all Media Assets thumbnails mounting at once) is capped, not just per-call.
// Before making the actual network call, check whether the caller has since marked
// its asset state as inactive (e.g. the creative was switched while this request was
// still queued behind the concurrency limit) - if so, skip the call entirely rather
// than firing a request nobody wants the result of. Requests already in flight when
// their asset state becomes inactive are left to complete normally, since they've
// already had their concurrency slot and cancelling them mid-flight isn't necessary here.
const FETCH_FILE_CONCURRENCY_LIMIT = 10;
const limit = pLimit(FETCH_FILE_CONCURRENCY_LIMIT);
const fetchFileLimited = (campaignId, payload) => limit(() => {
  if (payload.assetState && !payload.assetState.isActive) return Promise.reject(new Error('Request is no longer active'));
  return storageApi.getFile(campaignId, payload);
});

const actions = {
  [types.FETCH_CAMPAIGN_FILE_NAMES]: (context, payload) => storageApi.getFileNames(context.rootState.campaigns.campaign.id, payload)
    .then((response) => response?.files?.map((file) => file.name)),
  [types.FETCH_CAMPAIGN_FILE]: (context, payload) => fetchFileLimited(context.rootState.campaigns.campaign.id, payload)
    .then((response) => response.content)
    .catch(() => []),
  [types.DELETE_CAMPAIGN_FILE]: (context, payload) => storageApi.deleteFile(context.rootState.campaigns.campaign.id, payload)
    .then((response) => response)
    .catch((error) => error),
};

export default actions;
